
/* ---------------------------------------------------------------
                    BOILERPLATE - LEAFLET MAP
/* ---------------------------------------------------------------

A simple leaflet map with hardcoded markers.

Chart is redrawn when:
- A) a new option is chosen from select element
- B) element is resized.

Chart's responsiveness follows 'progressive disclosure philosophy'. More parts of the graph
appear in the DOM as the graph is resized. To adjust these elements, including margins, adjust
chart.js

Note: tween module is no longer used in transition but I've left it in case we want to re-use it.

When adapting this boilerplate don't forget to change:
- filenames and data names in loadAndProcessData
- annotation positions and names in chart.js
 */


// --------------------------- IMPORTS ---------------------------

// Third party
import {select} from 'd3-selection'
import debounce from 'debounce';

// My imports
import { loadAndProcessData } from "./loadAndProcessData";
import { drawMap } from './map';

// --------------------------- CANVAS SETUP AND BASIC PROPS ---------------------------

  // SET BASIC PROPS
  const breakpointSmallScreen = 400;

  // SET ELEMENT PROPS
  const mapContainerClass = 'graphic__map'
  const legendContainerClass = 'container__legend' // don't include . with class name
  const graphicInner = select(".graphic__inner");

  // STORE PROPS
  const props = {
    mapContainerClass,
    legendContainerClass,
    graphicInner,
    breakpointSmallScreen,
  }

// --------------------------- LOAD DATA AND DRAW GRAPHIC ---------------------------

loadAndProcessData().then(rawData => {

  // --------------------------- RESIZE ---------------------------

  // actions to perform when screen resizes
  function resize() {
    pymChild.sendHeight(); // updates height if graphic is being displayed in iframe
  }

  // ------------------------------------- INIT ----------------------------------
  
  // Sets up our map + event listeners when page loads
  function init() {

    drawMap(rawData, props)

    // add event listner for any resizes (listener is debounced)
    window.addEventListener("resize", debounce(resize, 200));
  }

  // ------------------------------------- START ----------------------------------

  init()

});



